import {
  VideoIcon,
  PhoneIcon,
  MailIcon,
  LinkedinIcon,
  FacebookIcon,
  InstagramIcon,
  PinterestIcon,
} from "../icons/NavbarIcons";
import { CONTACT_INFO, SOCIAL_LINKS } from "./constants";

type TopBarProps = {
  iconColor: string;
};

export function TopBar({ iconColor }: TopBarProps) {
  const iconClass = `w-3 h-3 shrink-0 lg:w-3.5 lg:h-3.5 xl:w-4 xl:h-4 2xl:w-5 2xl:h-5 ${iconColor}`;

  const renderSocialIcon = (iconName: string) => {
    const className = `w-3 h-3 lg:w-3.5 lg:h-3.5 xl:w-4 xl:h-4 2xl:w-5 2xl:h-5 ${iconColor}`;
    switch (iconName) {
      case "LinkedinIcon":
        return <LinkedinIcon className={className} />;
      case "FacebookIcon":
        return <FacebookIcon className={className} />;
      case "InstagramIcon":
        return <InstagramIcon className={className} />;
      case "PinterestIcon":
        return <PinterestIcon className={className} />;
      default:
        return null;
    }
  };

  return (
    <div className="hidden md:flex justify-between items-center border-b border-gray-100 text-sm py-1.5 lg:py-2 xl:py-2.5 2xl:py-4 px-3 sm:px-4 lg:px-6 xl:px-12 2xl:px-32 gap-2">
      <div className="min-w-0">
        <ul className="flex font-semibold items-center flex-wrap gap-x-2 lg:gap-x-3 xl:gap-x-4">
          <li className="min-w-0">
            <div className="flex items-center min-w-0">
              <VideoIcon className={iconClass} />
              <a
                href={CONTACT_INFO.zoom}
                className="flex items-center min-w-0"
                title="Zoom"
              >
                <span className="ml-1 lg:ml-1.5 truncate max-w-[100px] lg:max-w-[140px] xl:max-w-none text-[10px] lg:text-[11px] xl:text-xs 2xl:text-sm">
                  {CONTACT_INFO.zoom}
                </span>
              </a>
            </div>
          </li>
          <li className="ml-1 lg:ml-2 xl:ml-3 2xl:ml-5">
            <a href={`tel:${CONTACT_INFO.phoneRaw}`} className="flex items-center">
              <PhoneIcon className={iconClass} />
              <span className="ml-1 lg:ml-1.5 text-[10px] lg:text-[11px] xl:text-xs 2xl:text-sm whitespace-nowrap">
                {CONTACT_INFO.phone}
              </span>
            </a>
          </li>

          <li className="ml-1 lg:ml-2 xl:ml-3 2xl:ml-5 hidden lg:block">
            <a href={`mailto:${CONTACT_INFO.email}`} className="flex items-center">
              <MailIcon className={iconClass} />
              <span className="ml-1 lg:ml-1.5 text-[10px] lg:text-[11px] xl:text-xs 2xl:text-sm whitespace-nowrap">
                {CONTACT_INFO.email}
              </span>
            </a>
          </li>
        </ul>
      </div>

      <div className="shrink-0">
        <ul className="flex justify-end items-center gap-2 lg:gap-3 xl:gap-4 2xl:gap-5">
          {SOCIAL_LINKS.map((link) => (
            <li key={link.label}>
              <a
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                title={link.label}
                aria-label={link.label}
                className="inline-flex"
              >
                {renderSocialIcon(link.iconName)}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
